import script from "./job_requests.vue?vue&type=script&setup=true&lang=js"
export * from "./job_requests.vue?vue&type=script&setup=true&lang=js"

import "./job_requests.vue?vue&type=style&index=0&id=cccf003e&lang=css"

const __exports__ = script;

export default __exports__